'use client';

import { ReactNode } from 'react';

import { CircleAnimationContent } from './CircleAnimationContent';
import styles from './CircleAnimation.module.scss';

interface ImproveAnimationProps {
  children?: ReactNode;
}

export function CircleAnimation({ children }: ImproveAnimationProps) {
  return (
    <span className={styles.wrapper}>
      <span className={styles.content}>{children}</span>
      <CircleAnimationContent />
    </span>
  );
}
